import React, { useState } from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Line } from 'react-chartjs-2';

import { useGarageController } from 'src/controllers/Dashboard/Garage/GarageController';
import { useFinishOrderServiceListController } from 'src/controllers/OrderService/ListFinishOrderServiceControle';
import { Dropdown } from 'primereact/dropdown';
import { dateToString } from 'src/utils/dateToString';

const GarageDashboard: React.FC = () => {
	const { getGarageDashboard, handleGarageDashboard } = useGarageController();
	const { getFinishOrderServiceListController } = useFinishOrderServiceListController();

	const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

	let thisYear = new Date().getFullYear();
	let iterableYears = new Date().getFullYear() - 10;
	let datesArray = [];
	while (iterableYears <= thisYear) {
		datesArray.push(iterableYears);
		iterableYears++;
	}

	const data = {
		labels: [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		],
		datasets: [
			{
				label: 'Serviços realizados',
				data: getGarageDashboard.garageDataMonth?.SERVICO_ANO.map((amount) => {
					return amount.QUANTIDADE_SERVICO;
				}),
				fill: false,
				backgroundColor: 'rgb(54, 162, 235)',
				borderColor: 'rgba(54, 162, 235, 0.2)',
			},
		],
	};

	const options = {
		scales: {
			yAxes: [
				{
					ticks: {
						beginAtZero: true,
					},
				},
			],
		},
	};

	const HEADER_VEICULO = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Veículo</span>
				{rowData.DESCRICAO_VEICULO}
			</React.Fragment>
		);
	};
	const HEADER_PLACA_VEICULO = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Placa</span>
				{rowData.PLACA_VEICULO}
			</React.Fragment>
		);
	};
	const HEADER_DESCRICAO_DEMANDA = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Demanda</span>
				{rowData.DESCRICAO_DEMANDA}
			</React.Fragment>
		);
	};
	const HEADER_VEICULOKM = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Hodômetro</span>
				{rowData.VEICULOKM}
			</React.Fragment>
		);
	};
	const HEADER_DATAEFETIVADA = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Data</span>
				{dateToString(rowData.DATAEFETIVADA, 'br')}
			</React.Fragment>
		);
	};
	const HEADER_TIPOORDEMSERVICO = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Manutenção</span>
				{rowData.DESCRICAO_TIPOORDEMSERVICO}
			</React.Fragment>
		);
	};

	const HEADER_VEICULO_MODELO = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Modelo</span>
				{rowData.VEICULO_MODELO}
			</React.Fragment>
		);
	};
	const HEADER_PLACA = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Placa</span>
				{rowData.PLACA}
			</React.Fragment>
		);
	};
	const HEADER_RECORRENCIA = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Quantidade de Serviços</span>
				{rowData.RECORRENCIA}
			</React.Fragment>
		);
	};

	return (
		/**
		 * Adicionar wrap em textos para evitar que os textos fiquem se sobrepondo
		 */
		<div>
			<div className='card'>
				<h4>Dashboard da Garagem</h4>
			</div>
			<div className='p-grid p-fluid dashboard'>
				<div className='p-col-12 p-md-4'>
					<div className='card summary'>
						<span className='title'>Demandas</span>
						<span className='detail'>Pendentes</span>
						<span className='count purchases'>
							{getGarageDashboard.loading ? (
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							) : (
								getGarageDashboard.garageData?.QUANTIDADE_DEMANDA || 0
							)}
						</span>
					</div>
				</div>
				<div className='p-col-12 p-md-4'>
					<div className='card summary'>
						<span className='title'>Serviços</span>
						<span className='detail'>Em andamento</span>
						<span className='count revenue'>
							{getGarageDashboard.loading ? (
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							) : (
								getGarageDashboard.garageData?.QUANTIDADE_SERVICO || 0
							)}
						</span>
					</div>
				</div>
				<div className='p-col-12 p-md-4'>
					<div className='card summary'>
						<span className='title'>Gastos</span>
						<span className='detail'>em manutenção</span>
						<span className='count visitors'>
							{getGarageDashboard.loading ? (
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							) : (
								Intl.NumberFormat('pt-BR', {
									style: 'currency',
									currency: 'BRL',
								}).format(getGarageDashboard.garageData?.CUSTOMANUTENCAO.PRODUTO || 0)
							)}
						</span>
					</div>
				</div>
			</div>

			<div className='p-grid'>
				<div className='p-col-12 p-md-6'>
					<div className='card'>
						<h6>Manutenções finalizadas</h6>

						<DataTable
							className='p-datatable-sm dashboard-table'
							rowHover
							value={getFinishOrderServiceListController.finishOrderServiceData}
							scrollable
							scrollHeight='512px'
							autoLayout>
							<Column field='DESCRICAO_VEICULO' header='Veículo' body={HEADER_VEICULO} />
							<Column field='PLACA_VEICULO' header='Placa' body={HEADER_PLACA_VEICULO} />
							<Column field='DESCRICAO_DEMANDA' header='Demanda' body={HEADER_DESCRICAO_DEMANDA} />
							<Column field='VEICULOKM' header='Hodômetro' body={HEADER_VEICULOKM} />
							<Column field='DATAEFETIVADA' header='Data' body={HEADER_DATAEFETIVADA} />
							<Column
								field='DESCRICAO_TIPOORDEMSERVICO'
								header='Manutenção'
								body={HEADER_TIPOORDEMSERVICO}
							/>
						</DataTable>
						{getFinishOrderServiceListController.loading ? (
							<div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							</div>
						) : (
							<></>
						)}
					</div>
				</div>

				<div className='p-col-12 p-md-6'>
					<div className='card'>
						<h6>Veículos mais recorrentes</h6>

						<DataTable
							className='p-datatable-sm dashboard-table'
							rowHover
							value={getGarageDashboard.garageData?.VEICULO_RECORRENCIA}
							scrollable
							scrollHeight='512px'
							autoLayout>
							<Column field='VEICULO_MODELO' header='Modelo' body={HEADER_VEICULO_MODELO} />
							<Column field='PLACA' header='Placa' body={HEADER_PLACA} />
							<Column field='RECORRENCIA' header='Quantidade de Serviços' body={HEADER_RECORRENCIA} />
						</DataTable>
						{getGarageDashboard.loading ? (
							<div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							</div>
						) : (
							<></>
						)}
					</div>
				</div>

				<div className='p-col-12'>
					<div className='card'>
						<div>
							<h4>Resumo</h4>
							<p>Período Selecionado:</p>
							<Dropdown
								id='datas'
								options={datesArray}
								value={currentYear}
								onChange={(e) => {
									handleGarageDashboard.getDashboardMonthData(e.value);
									setCurrentYear(e.value);
								}}
							/>
						</div>

						{getGarageDashboard.loadingMonth ? (
							<div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '2em' }}></i>
							</div>
						) : (
							<Line data={data} options={options} />
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default GarageDashboard;
